import { VideoJsPlaybackProvider } from '@app/core/playback/video/VideoPlaybackProvider';
import { isStationTranscriptionEnabled } from '@app/modules/fragments/screens/view/components/transcription/lib/is-transcription-enabled';
import { toTimestamp } from '@mi-front/core';
import { Box } from '@mui/material';
import { PlaybackVideoJsPlayer } from '../../../../../../../core/video-player/PlaybackVideoJsPlayer';
import { useFragment } from '../../../hooks/useFragment';
import { FragmentChaptersAttachment } from './chapters/FragmentChaptersAttachment';
import { FragmentSubtitlesAttachment } from './subtitles/FragmentSubtitlesAttachment';

/**
 * Main component to display the video player for a fragment.
 * Uses VideoPlaybackProvider to manage the player state.
 * When children are provided, renders the provider and children only (no default player/transcription).
 * When no children, renders player and transcription below it.
 */
export function VideoFragmentMedia() {
  const { fragment, station } = useFragment();
  const videoUrl = fragment.assets.video?.url;
  const hasSubtitles =
    isStationTranscriptionEnabled(station) && Boolean(fragment.transcriptionCompletedAt);

  if (!videoUrl) {
    return null;
  }

  return (
    <VideoJsPlaybackProvider
      src={videoUrl}
      playbackRange={{ from: toTimestamp(fragment.from), to: toTimestamp(fragment.to) }}
    >
      {hasSubtitles && (
        <FragmentSubtitlesAttachment fragmentId={fragment.id!} srclang={station.language} />
      )}
      <FragmentChaptersAttachment description={fragment.description} />
      <Box
        sx={{
          margin: '0 auto',
        }}
      >
        <PlaybackVideoJsPlayer bordered />
      </Box>
    </VideoJsPlaybackProvider>
  );
}
